import React, { useState, useEffect, useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import axios from '../../Utils/axios'
import to from 'await-to-js'
import { toaster, Table, Heading, Icon, Button, Text, Spinner, Tab } from 'evergreen-ui';
import { monetaryConverter } from '../../Utils/converter';
import ActivityDetail from '../ActivityDetail'
import * as moment from 'moment'
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import { CSVLink } from "react-csv";

const ActivitiesList = ({
  history, match
}) => {
  const [activities, setActivties] = useState([])
  const [visible, setVisible] = useState(false)
  const [detailedItem, setDetailedItem] = useState(null)
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState('all');
  const [traveled, setTraveled] = useState(0)
  const [expenses, setExpenses] = useState(0)


  const headers = [
    { label: "Tipo", key: "type" },
    { label: "Início", key: "start" },
    { label: "Término", key: "end" },
    { label: "Evento", key: "event" },
    { label: "Observação", key: "note" },
    { label: "Custo/KM", key: "cost" },
    { label: "Recurso", key: "resource" },
    { label: "Cidade inicial", key: "initialCity" },
    { label: "Cidade final", key: "finalCity" },
    { label: "Resultado", key: "closureNote" },
  ];

  const csvData = activities.map(activity => {
    return {
      type: activity.type.toLowerCase() === "resource" ? 'Atividade' : 'Despesa',
      start: moment(activity.createdAt).add(-3, 'h').format('DD/MM/YYYY HH:mm'),
      end: activity.type.toLowerCase() === 'resource'
      ? moment(activity.terminatedAt).add(-3, 'h').format('DD/MM/YYYY HH:mm')
      : 'Não aplicável',
      event: activity.type.toLowerCase() === 'resource' ?
      activity.activity : activity.name,
      note: activity.note,
      cost: activity.type.toLowerCase() !== 'resource' ? `R$ ${monetaryConverter(activity.value)}` : !!activity.value ? `${Number(activity.value).toLocaleString()} km` : 'Recurso não requer km',
      resource: activity.type.toLowerCase() === 'resource' ? activity.name : '',
      initialCity: activity.initialCity,
      finalCity: activity.finalCity,
      closureNote: activity.closureNote ? activity.closureNote : '',
    }
  })

  const { employeeName } = (history.location && history.location.state) || {}

  const handlePrint = useCallback(async () => {
    const { vfs } = vfsFonts.pdfMake;
    const { employeeId } = match.params
    const { dates } = (history.location && history.location.state) || {}
    pdfMake.vfs = vfs;

  
    setLoading(true)
    const queryParams = `?fromDate=${encodeURIComponent(dates.dateFrom)} 00:00:00&toDate=${encodeURIComponent(dates.dateTo)} 23:59:59&filter=${filter}`
    const response = await axios.get(`company/activities/employee/${employeeId}/activity-report${queryParams}`)
    const { content, styles } = response.data;
    setLoading(false)

     pdfMake.createPdf({
       content,
       styles
     }).open()
  }, [match.params, history.location, filter])

  const getActivitiesList = useCallback(async (employeeId, dates) => {
    let queryParams

    if (dates) {
      queryParams = `?fromDate=${encodeURIComponent(dates.dateFrom)} 00:00:00&toDate=${encodeURIComponent(dates.dateTo)} 23:59:59`
    }
    else {
      queryParams = `?`
    }
    const URI = `/company/activities/employee/${employeeId}${queryParams}`
    const [err, res] = await to(axios.get(URI))

    if (err) {
      toaster.danger(err.response.data.error)
    }


    const KMValues = res.data.activities.map(activity =>{
      if (activity.type === 'RESOURCE') {
        return Number(activity.value)
      }
        return 0
    });

    const expensesValues = res.data.activities.map(activity =>{
      if (activity.type === 'EXPENSE') {
        return activity.value
      } 
        return 0
    });


    const totalExpenses = expensesValues.reduce(function (acc, curr) {
       return acc + Number(curr)
    }, 0)
    const totalKM = KMValues.reduce(function (acc, curr) {
      return acc + Number(curr)
   }, 0)

    setExpenses(totalExpenses)
    setTraveled(totalKM)

    if (filter === 'all') {
       setActivties(res.data.activities)
    } else {
      setActivties(res.data.activities.filter(activity => activity.type === filter))
    }
  }, [filter])

  const detail = (activity) => {
    setVisible(true)
    setDetailedItem(activity)
  }

  useEffect(() => {
    const { employeeId } = match.params
    const { dates } = (history.location && history.location.state) || {}

    getActivitiesList(employeeId, dates)
  }, [match, history, getActivitiesList])

  if (activities.length ===  0 ) {
    return  <Heading size={600} style={{ marginLeft: 10, color: 'red' }}> Não há dados para consultar</Heading>
  }

  return (
    <>
      <Heading size={600} style={{ marginLeft: 16 }}>Lista de atividades {employeeName}</Heading>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', margin: 16 }}>
          <div>
          {
            loading ? (
              <div>
                <Spinner size={24} />
                <Text marginLeft={8}>Gerando relatório...</Text>
              </div>
            ): (
              <Button marginRight={20} iconBefore="search" onClick={() => handlePrint()} > Gerar relatório </Button>
            )
          }
          <Button marginRight={20} iconBefore="manual"> <CSVLink separator={";"} data={csvData} headers={headers}>Gerar CSV</CSVLink> </Button>


          <Tab  isSelected={filter === 'all'} onClick={()=> setFilter('all')}>Todos</Tab>
          <Tab isSelected={filter === 'RESOURCE'} onClick={()=> setFilter('RESOURCE')}>Atividades</Tab>
          <Tab isSelected={filter === 'EXPENSE'} onClick={()=> setFilter('EXPENSE')}>Despesas</Tab>
        </div>

        <div style={{display: 'flex', color: '#234361'}}>
          <p>Total percorrido: {traveled.toLocaleString()} km </p>
          <p> - </p>
          <p>Total gasto: R$ {expenses.toLocaleString()}</p>
        </div>
      </div>
      
      <Table style={{ marginRight: 10, marginLeft: 10, marginTop: 20 }}>
        <Table.Head>
          <Table.TextCell flexGrow={0} flexShrink={0} flexBasis={50}>
            Tipo
          </Table.TextCell>
          <Table.TextCell>
            Início
          </Table.TextCell>
          <Table.TextCell>
            Término
          </Table.TextCell>
          <Table.TextCell>
            Evento
            </Table.TextCell>
          <Table.TextCell>
            Observação
            </Table.TextCell>
          <Table.TextCell>Custo&nbsp;/&nbsp;KM</Table.TextCell>
          <Table.TextCell>Recurso </Table.TextCell>
          <Table.TextCell>Cidade inicial</Table.TextCell>
          <Table.TextCell>Cidade final</Table.TextCell>
          <Table.TextCell flexGrow={0} flexShrink={0} flexBasis={70}>Anexos</Table.TextCell>
          <Table.TextCell flexGrow={0} flexShrink={0} flexBasis={70}>Mapa</Table.TextCell>
        </Table.Head>

        <Table.Body height={600}>
          {
          activities.sort((a, b) => b.createdAt < a.createdAt).map((activity, index) => {
            const files = activity.files ? activity.files.split(',') : []
            return (
              <>
                <Table.Row key={index}>
                  <Table.TextCell flexGrow={0} flexShrink={0} flexBasis={50}>
                    <Icon icon={
                      activity.type.toLowerCase() !== 'resource' ? 'dollar' : 'taxi'
                    } size={15} />
                  </Table.TextCell>
                  <Table.TextCell>
                  { moment(activity.createdAt).add(-3, 'h').format('DD/MM/YYYY HH:mm') }
                  </Table.TextCell>
                  <Table.TextCell>
                  {
                    activity.type.toLowerCase() === 'resource'
                      ? moment(activity.terminatedAt).add(-3, 'h').format('DD/MM/YYYY HH:mm')
                      : 'Não aplicável'
                  }
                  </Table.TextCell>
                  <Table.TextCell> {activity.type.toLowerCase() === 'resource' ?
                    activity.activity : activity.name} </Table.TextCell>
                  <Table.TextCell> {activity.note} </Table.TextCell>
                  {activity.type.toLowerCase() !== 'resource' && (
                    <Table.TextCell> R$ {monetaryConverter(activity.value)} </Table.TextCell>
                  )}
                  {activity.type.toLowerCase() === 'resource' && (
                    <Table.TextCell>
                      {!!activity.value ? Number(activity.value).toLocaleString() : 'Recurso não requer'} km
                    </Table.TextCell>
                  )}
                  <Table.TextCell> {activity.type.toLowerCase() === 'resource' ? activity.name : null} </Table.TextCell>
                  <Table.TextCell> {activity.initialCity} </Table.TextCell>
                  <Table.TextCell> {activity.finalCity} </Table.TextCell>
                  <Table.TextCell flexGrow={0} flexShrink={0} flexBasis={70}>
                  {
                    files.map((file, index) => (
                      <a
                        style={{display: 'flex', color: '#1070CA', fontWeight: 'bold', marginBottom: '5px'}}
                        key={index}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={file}
                      >{`Anexo ${index + 1}`}
                      </a>
                    ))
                  }
                  </Table.TextCell>
                  <Table.TextCell flexGrow={0} flexShrink={0} flexBasis={70}>
                    <Icon icon='search'
                      size={20}
                      onClick={() => detail(activity)} />
                  </Table.TextCell>
                </Table.Row>
                {activity.closureNote &&
                  <Table.Row style={{ background: '#ffffe5' }}>
                    <Table.TextCell><b>Resultado da tarefa: </b>{activity.closureNote}</Table.TextCell>
                  </Table.Row>
                }
              </>
            )})}
        </Table.Body>
      </Table >
      {visible && <ActivityDetail visible={visible} close={() => setVisible(false)} detailedItem={detailedItem} />}
    </>
  )
}

export default withRouter(ActivitiesList)
